import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Navbar = ({ activeTab, navigateTo, logoImg, isMobile }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = ['home', 'about', 'products', 'certifications', 'gallery', 'contact'];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavigate = (tab) => {
    navigateTo(tab);
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-dark-900 shadow-lg border-b border-dark-800">
      <div className="px-4 md:px-8">
        {/* Top Bar */}
        <div className="relative flex items-center justify-between py-4 md:py-5">
          {/* Logo Section */}
          <div className="flex items-center gap-3 md:gap-6 flex-1">
            <img
              src={logoImg}
              alt="Hanuman Global Logo"
              className="h-14 md:h-20 w-auto object-contain"
              style={{ mixBlendMode: 'lighten', filter: 'contrast(1.1)' }}
            />
          </div>

          {/* Mobile Menu Toggle */}
          {isMobile && (
            <button
              onClick={toggleMenu}
              className="text-accent hover:bg-dark-800 p-2 rounded-lg transition-colors"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          )}

          {/* Navigation Menu */}
          <nav
            className={`
              ${isMobile
                ? `${isMenuOpen ? 'flex' : 'hidden'} absolute left-0 right-0 top-full flex-col gap-4 bg-dark-900 px-4 pb-4`
                : 'flex flex-row gap-8 pl-8'}
              transition-all duration-300
            `}
          >
            {navItems.map((tab) => (
              <button
                key={tab}
                onClick={() => handleNavigate(tab)}
                className={`
                  text-sm md:text-xs font-bold tracking-widest uppercase text-left
                  px-3 py-2 md:px-0 md:py-0 rounded-lg md:rounded-none
                  transition-colors duration-200
                  ${
                    activeTab === tab
                      ? 'text-accent bg-dark-800 md:bg-transparent'
                      : 'text-white hover:text-accent md:hover:text-accent'
                  }
                `}
              >
                {tab === 'gallery' ? 'Operations' : tab}
              </button>
            ))}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
